const mergeIssueNoteMessages = (persisted = [], optimistic = []) => {
   const byId = new Map();

   optimistic.forEach((message) => {
      if (!message || message._id == null) return;
      byId.set(String(message._id), { ...message });
   });

   persisted.forEach((message) => {
      if (!message || message._id == null) return;
      const key = String(message._id);
      byId.set(key, {
         ...(byId.get(key) || {}),
         ...message,
         pending: false,
         failed: false
      });
   });

   return Array.from(byId.values()).sort((a, b) => {
      const left = new Date(a.createdAt || 0).getTime();
      const right = new Date(b.createdAt || 0).getTime();
      return left - right;
   });
};

export { mergeIssueNoteMessages };
